// InteractionItem.js
import React from "react";
import "./InteractionItem.css";
import { formatDate } from "../../utils/dateUtils";

const InteractionItem = ({ interaction, currentRepId }) => {
  const createdAt = interaction.created_at
    ? formatDate(interaction.created_at)
    : "N/A";
  
  const followUpDate = interaction.follow_up_date
    ? formatDate(interaction.follow_up_date)
    : "N/A";

  // Check if this interaction was created by the current rep
  const isCurrentRep = interaction.added_by === currentRepId;

  return (
    <div className={`interaction-item ${!isCurrentRep ? 'previous-rep' : ''}`}>
      <div className="interaction-header">
        <strong>{interaction.interaction_type}</strong>
        <span className="interaction-created-at">{createdAt}</span>
      </div>
      <div className="interaction-rep">
        {interaction.rep_name || 'Unknown rep'}
      </div>
      {interaction.note && (
        <p className="interaction-note">{interaction.note}</p>
      )}
      <div className="interaction-details">
        <div className="detail-row">
          <span className="interaction-label">Outcome: </span>
          <span className="interaction-value">
            {interaction.outcome || "N/A"}
          </span>
        </div>
        <div className="detail-row">
          <span className="interaction-label">Next Step: </span>
          <span className="interaction-value">
            {interaction.next_step || "N/A"}
          </span>
        </div>
        <div className="detail-row">
          <span className="interaction-label">Follow Up: </span>
          <span className="interaction-value">{followUpDate}</span>
        </div>
      </div>
      {(interaction.old_status || interaction.new_status) && (
        <div className="interaction-status-change">
          <span className="interaction-label">Status Change: </span>
          <span className="interaction-value">
            {interaction.old_status || "N/A"} → {interaction.new_status || "N/A"}
          </span>
        </div>
      )}
    </div>
  );
};

export default InteractionItem;
